import axios from 'axios'; // 引入axios
// import qs from 'qs'; // 引入qs
import APIUrl from './api.url'; // 引入api.url.js
import router from '../router/index';
import {
  Loading
} from 'element-ui';

// axios 默认配置  更多配置查看Axios中文文档
axios.defaults.timeout = 600000; // 超时默认值
axios.defaults.baseURL = APIUrl.baseURL+"/api"; // 默认baseURL

// axios.defaults.headers.common['Authorization'] = "";
// axios.defaults.responseType  = 'json'         // 默认数据响应类型

// axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.withCredentials = true; // 表示跨域请求时是否需要使用凭证

// let loadingInstance = Loading.service();

// http request 拦截器
// 在ajax发送之前拦截 比如对所有请求统一添加header adminToken
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    Loading.service({
      background: 'transparent'
    });
    // if (adminToken) {
    //     config.headers.Authorization = `adminToken ${adminToken}`;
    // }
    return config;
  },
  err => {
    // 对请求错误做些什么
    Loading.service().close();
    return Promise.reject(err);
  }
);

// // http response 拦截器
// // ajax请求回调之前拦截 对请求返回的信息做统一处理 比如error为401无权限则跳转到登陆界面
axios.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    Loading.service().close();
    console.log(response.data.code)
    switch (response.data.code) {
      case 401:
        console.log("401，未登录");
        router.push({path:"/login"});
        break;
      default:
        break;
    }
    return response;
  },
  error => {
    // 对响应错误做点什么
    Loading.service().close();
    console.log(error);
    return Promise.reject(error);
  }
);

export default axios; // 这句千万不能漏下！！！

var adminViewId;
var adminToken;

function getCookie() {
  if(!localStorage.getItem('stkMessage')){
    return
  }
  var stkMessage = JSON.parse(localStorage.getItem('stkMessage'))
  console.log(stkMessage)
  adminViewId = stkMessage.viewId
  adminToken = stkMessage.token
  console.log(adminViewId,"adminViewId")
  console.log(adminToken,"adminToken")
}
getCookie();
console.log("adminViewId,adminToken======" + adminViewId, adminToken);

/**
 * post 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data) {
  return axios({
    method: 'post',
    url: url,
    data: data,
    dataType: 'json',
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'adminViewId': `${adminViewId}`,
      'adminToken': `${adminToken}`
    }
  })
}

// chen 添加购物车
export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      'adminViewId': `${adminViewId}`,
      'adminToken': `${adminToken}`
    }
  })
}
/**
 * get 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params) {
  return axios({
    method: 'get',
    url: url,
    params: params,
    transformRequest: [function (data) {
      // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'adminViewId': `${adminViewId}`,
      'adminToken': `${adminToken}`
    }
  })
}

// chen 添加购物车
export const newpostRequest = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'adminViewId': `${adminViewId}`,
      'adminToken': `${adminToken}`
    }
  })
}



// WEBPACK FOOTER //
// ./src/axios/index.js